import React from 'react';

const OfficeViewer = ({
    document
}) => {
    const officeViewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
        document?.presigned_url || ''
    )}`;

    return (
        <div className="h-full flex flex-col w-full overflow-hidden bg-white relative">
            <div className="absolute top-0 left-0 w-full h-full">
                <iframe
                    title="Office Viewer"
                    src={officeViewerUrl}
                    className="w-full h-full bg-white"
                    frameBorder="0"
                    onError={() => {

                    }}
                />
            </div>
        </div>
    );
};

export default OfficeViewer;